<template>
	<div>

		<div class="container">
			<div class="logoBox">
				<div class="logoMark" style="padding: 10px;">
					<!--<div class="logoText">ATM</div>-->
					<img src="images/logo_atm.png" style="width: 100%;" />
				</div>
			</div>

			<div class="banner section">
				<div class="big"><span data-lang="t_22"></span><span
						style="color: aqua;">{{"#" + Number(userID).toString(16).toLocaleUpperCase()}}</span></div>
				<div class="big"><span data-lang="t_23"></span><span
						style="color: aqua;">{{"#" + Number(RefId).toString(16).toLocaleUpperCase()}}</span></div>
				<div class="small">
					<span class="big" style="color: azure;">{{userTitle}}：</span>
					<span style="color: #F00;font-size: 1.2rem;">{{userType}}</span><br>
					
					<span class="big" style="color: #0F0;">{{CaoJieShang}}</span>
				</div>
			</div>

			<div class="card section">
				<div class="row" style="padding:14px">
					<div>
						<div class="title" data-lang="t_24"></div>
						<div class="muted" ><div  @click="Announcement = 1" style="color: #FFF;font-size: 10;">新加坡比特龙ATM基金会与BCTM(链市)去中心化交易所达成战略协议</div></div>
						<div class="muted" ><div  @click="Announcement = 2" style="color: #F00;font-size: 10;">ATM基金会与BCTM交易所战略合作正式启动</div></div>

						<div class="muted" ><div  @click="Announcement = 3" style="color: #F00;font-size: 10;">关于做市商入驻的重要通知</div></div>

					</div>
				</div>
			</div>

			<div class="card section">
				<div class="row" style="padding:14px 14px 0">
					<div class="h2" data-lang="t_27"></div>
					<span class="pill" data-lang="t_28"></span>
				</div>
				<div class="list" style="padding:14px">
					<TeamTreeNode v-for="item in teamData" :key="item.id" :node="item" />
				</div>
			</div>
		</div>

		<!-- 公告弹窗 -->
		<div class="modalMask" :class="{show:Announcement > 0}">
			<div class="modal">
				<div class="modalHead">
					<div>公告</div>
					<div class="modalClose" @click="Announcement = 0">×</div>
				</div>
				<div class="modalBody">
					
					<div v-if="Announcement == 1" class="reward_container">
						<div class="reward_title">新加坡比特龙ATM基金会与BCTM(链市)去中心化交易所达成战略协议</div>
						
						<div class="reward_intro">
							BCTM(链市)去中心化交易所是一个类似hype的交易所，将于2026年7月7日向全球招募股东。届时，ATM用户将会按投入资金平移到该交易所，获得等额股东权益。
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">BCTM(链市)去中心化交易所</span>
								<span class="reward_desc">
									<span class="reward_highlight">
										BCTM(链市)去中心化交易所是一个类似hype的交易所，是集交易、永续合约、理财等多种功能于一体的完全去中心化综合性交易平台。
									</span>									
								</span>
							</div>
						
							<div class="reward_item">
								<span class="reward_level">股东权益</span>
								<span class="reward_desc">
									<span class="reward_highlight">✅ 股东月化保底分红3%</span><br>	
									<span class="reward_highlight">✅ 根据交易所收益（交易手续费，永续合约交易手续费，市值管理收益等）给股东分红。所有股份同股同权，</span>	
								</span>
							</div>
							<div class="reward_item">
								<span class="reward_level">ATM平移制度</span>
								<span class="reward_desc">
									<span class="reward_highlight">无论你在ATM获得了多少收益和利润，只计算你的投资金额进行平移</span>
								</span>
							</div>
						</div>
						<div class="reward_footer">
							<div>宣发单位：新加坡比特龙ATM基金会万事达集团</div>
							<div class="reward_date">（公告日期：2026年06月05日）</div>
						</div>
					</div>
					<div v-if="Announcement == 2" class="reward_container">
						<div class="reward_title">重大利好：ATM基金会与BCTM交易所战略合作正式启动</div>
						
						<div class="reward_intro">
							ATM基金会与<span class="reward_highlight" style="color: aqua;font-size: 18px;">链市</span> BCTM 去中心化订单簿永续合约交易所战略合作正式启动。
							已根据ATM用户投入的资金量，发放等值的 SBTCM 股份。该部分SBTCM初始为锁定状态，待交易所正式上线后，持有者可按持股比例参与平台手续费及其他收益的分红。
							对于计划在交易所上线前通过质押方式赚取BTCM平台币的ATM用户，我们特别争取到了 ATM 专属福利
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">SBCTM 价格</span>
								<span class="reward_desc">
									<span class="reward_highlight">
										SBCTM 兑换价格为1:10USDT，向任何人购买过ATM的用户都已经获得等价SBCTM，例如，花500U购买1000ATM，除去项目方扶持，本人出资400U，你将会获得40 SBCTM；
									</span>									
								</span>
							</div>
						
							<div class="reward_item">
								<span class="reward_level">ATM用户专属权益</span>
								<span class="reward_desc">
									<span class="reward_highlight"> ATM用户可申请成为扶持对象：标记为扶持对象的地址，在购买SBTCM股权时可享受 “买1送3” 优惠；</span><br>	
									<span class="reward_highlight"> 扶持地址后续推荐的下一级用户，将自动成为扶持对象，享受同等权益。</span>	
								</span>
							</div>
							<div class="reward_item" @click="copyAddress('https://x.debox.pro/ppcow7cp')">
								<span class="reward_level">专属权益申请方式</span>
								<span class="reward_desc">
									<span class="reward_highlight"><span class="reward_highlight">在debox联系基金会，debox下载链接：https://x.debox.pro/ppcow7cp(点击可复制)</span>	</span>
									
									<div style="weith:100%;text-align: center;">扫码加基金会好友</div>
									
									<img src="images/debox.jpg" style="width: 100%;border-radius: 12px;"/>
								</span>
								
							</div>
							
							<div class="reward_item"  @click="copyAddress('https://bctm.cc')">
								<span class="reward_level">SBCTM 官方网址</span>
								<span class="reward_desc">
									<span class="reward_highlight"><span class="reward_highlight">https://bctm.cc(点击可复制)</span>	</span>
								</span>
							</div>
							
							<div class="reward_item">
								<span class="reward_level">ATM项目步入新阶段</span>
								<span class="reward_desc">
									<span class="reward_highlight"><span class="reward_highlight">感谢大家一直以来的支持，经过大家共同持续努力，ATM项目已正式进入成熟发展期，ATM基金会后续将不再向市场注入母币，ATM全面转向市场化运作，完成由市场驱动。持币用户之间进行C2C交易，项目方仅收取手续费。</span>	</span>
								</span>
							</div>
						</div>
						<div class="reward_footer">
							<div>宣发单位：新加坡比特龙ATM基金会万事达集团</div>
							<div class="reward_date">（公告日期：2026年06月09日）</div>
						</div>
					</div>
					<div v-if="Announcement == 3" class="reward_container">
						<div class="reward_title">关于做市商入驻的重要通知</div>
						
						<div class="reward_intro">
							ATM基金会协手多个社区合作，市商进入，7月23日正式入驻。给大家带来不便敬请谅解
						</div>
						
						
						<div class="reward_footer">
							<div>宣发单位：新加坡比特龙ATM基金会万事达集团</div>
							<div class="reward_date">（公告日期：2026年06月30日）</div>
						</div>
					</div>
					
				</div>
				<div class="modalFoot">
					<button class="btn" @click="Announcement = 0">关闭</button>
				</div>
			</div>
		</div>

		<!-- Bottom Nav -->
		<div class="bottom">
			<div class="bottom-inner">
				<div class="nav active">
					<i class="fas fa-home"></i>
					<span data-lang="t_2"></span>

				</div>
				<div class="nav" data-lang="t_3"></div>
				<div class="nav" data-lang="t_4"></div>
				<div class="nav" data-lang="t_5"></div>
			</div>
		</div>
	</div>


</template>

<script>
	import TeamTreeNode from './child/TeamTreeNode.vue'
	export default {
		name: 'Home',
		components: {
			TeamTreeNode
		},
		data() {
			return {
				userID: 0,
				RefId: 0,
				userTitle: "",
				userType: "",
				teamData: [],
				Announcement: 0, //公告
				CaoJieShang:"",
			}
		},
		mounted() {
			
			this.showUI();
		},
		methods: {
			setLanguage() {
				const elements = document.querySelectorAll('[data-lang]');

				elements.forEach(element => {
					const langValue = element.getAttribute('data-lang');

					element.innerHTML = Lang[lg][langValue];
				});
			},
			copyAddress(text){
				copyRefURL(text);
				
			},
			async showUI() {
				//判断是否是超级商
				let cjs = await conCao.getCaoJieShang(Account).call();
				if(cjs)this.CaoJieShang = "尊贵的超级商";
				if(IsShowAnnouncement == true){
					IsShowAnnouncement = false;
					//如果是超级商，就显示超级商，否则显示2号公告
					if(cjs)this.Announcement=3//8//5;
					else 
						this.Announcement = 3//8//7;
				}
				this.setLanguage();
				const user = await conMine.getPeopleTree(Account).call();
				
				this.userID = user.id //Number(user.id).toString(16);
				this.RefId = user.fatherNode //Number(user.fatherNode).toString(16);
				
				if (user.Type == 1) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_3;
				} else if (user.Type == 2) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_33;
				} else if (user.Type == 3 || user.Type == 11) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_34;
				} else if (user.Type == 4 || user.Type == 12) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_35;
				}
				await Sleep(this.$waitTime);
				const child = await conMine.GetBrother(user.childNode, 100).call();

				if (child == null) return;
				const len = child.length;
				let point = 2;

				let index = 0;
				let team = [];
				while (point < len) {
					team[index] = {};
					team[index].id = Number("0x" + child.substring(point, point + 8));
					point += 8;
					team[index].people = Number("0x" + child.substring(point, point + 8));
					point += 8;
					team[index].totalMine = Number("0x" + child.substring(point, point + 8));
					point += 8;
					team[index].leval = Number("0x" + child.substring(point, point + 2));
					point += 2;
					team[index].quickenFloor = Number("0x" + child.substring(point, point + 2));
					point += 2;
					team[index].children = []; // 存储下级数据
					team[index].expanded = false; // 控制是否展开
					team[index].id = team[index].id.toString(16).toLocaleUpperCase(); //转换成16进制
					index++;
				}
				this.teamData = team;
			},
		},
	}
</script>
<style>
	.reward_container {

		color: #ffffff;
		font-family: 'Microsoft YaHei', 'Segoe UI', sans-serif;

		max-width: 800px;
		line-height: 1.7;

	}

	.reward_title {
		color: #00ffff;
		text-align: center;
		font-size: 1.5rem;
		margin-bottom: 6px;
		padding-bottom: 12px;
		border-bottom: 2px solid rgba(0, 255, 255, 0.3);
		text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
		letter-spacing: 2px;
	}

	.reward_intro {
		color: #cccccc;
		font-size: 0.8rem;
		margin-bottom: 25px;
		text-align: left;
		padding: 0 10px;
	}

	.reward_list {
		margin: 10px 0;
		padding-left: 0;
	}

	.reward_item {
		background: linear-gradient(90deg, rgba(0, 255, 255, 0.05), rgba(0, 255, 255, 0.02));
		border-left: 4px solid #00ffff;
		margin-bottom: 5px;
		padding: 6px 12px;
		border-radius: 0 8px 8px 0;
		transition: all 0.3s ease;
		position: relative;
		overflow: hidden;
		text-align: left;
	}

	.reward_item::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		height: 100%;
		width: 0;
		background: linear-gradient(90deg, rgba(0, 255, 255, 0.1), transparent);
		transition: width 0.5s ease;
		/* 【关键修复】让伪元素不响应鼠标事件，穿透点击到底层元素 */
		    pointer-events: none; 
		    z-index: 0; /* 确保它在内容之下 */
	}

	.reward_item:hover::before {
		width: 100%;
	}

	.reward_item:hover {
		transform: translateX(5px);
		box-shadow: 0 5px 15px rgba(0, 255, 255, 0.1);
	}

	.reward_level {
		color: #00ffff;
		font-weight: bold;
		font-size: 0.85rem;
		margin-bottom: 8px;
		display: block;
	}

	.reward_desc {
		color: #e0e0e0;
		font-size: 0.75rem;
		
	}

	.reward_highlight {
		color: #ffcc00;
		font-weight: bold;
		text-shadow: 0 0 5px rgba(255, 204, 0, 0.3);
	}

	.reward_call {
		text-align: center;
		font-size: 1.0rem;
		font-weight: bold;
		color: #00ffaa;
		margin: 6px 0;
		padding: 6px;
		background: rgba(0, 255, 170, 0.08);
		border-radius: 10px;
		border: 1px solid rgba(0, 255, 170, 0.2);
		animation: pulse 2s infinite;
	}

	@keyframes pulse {
		0% {
			box-shadow: 0 0 0 0 rgba(0, 255, 170, 0.4);
		}

		70% {
			box-shadow: 0 0 0 10px rgba(0, 255, 170, 0);
		}

		100% {
			box-shadow: 0 0 0 0 rgba(0, 255, 170, 0);
		}
	}

	.reward_contact {
		color: #aaaaaa;
		font-size: 0.7rem;
		text-align: center;
		margin: 6px 0;
		padding: 6px;
		background: rgba(255, 255, 255, 0.03);
		border-radius: 6px;
	}

	.reward_footer {
		font-size: 0.6rem;
		color: #888888;
		text-align: center;
		margin-top: 12px;
		padding-top: 6px;
		border-top: 1px solid #333333;
	}

	.reward_date {
		color: #999999;
		font-style: italic;
		margin-top: 5px;
	}
</style>